module.exports = __webpack_public_path__ + "OccupationalCropped-2c56e86c1c0e4dfebbb23854bfa83dfc.png";